import React from "react";

import { DivPx } from "@moai/core";
import { Privacy } from "./privacy/privacy";
import { Links } from "./links/links";
import s from "./footer.module.scss";
import { About } from "../about/about";
import { Border } from "../border/border";

interface Props {
    dataText: string;
    offlineMode: boolean;
}

export const Footer = ({ dataText, offlineMode }: Props) => (
    <div className={s.container}>
        <div className={s.space} />
        <div className={s.privacy}>
            <Privacy dataText={dataText} />
        </div>
        <div className={s.grow} />
        <div className={s.line}>
            <DivPx size={16} /> <Border color="strong" /> <DivPx size={16} />
        </div>
        <div className={s.links}>
            <Links offlineMode={offlineMode} />
        </div>
        <div className={s.line}>
            <DivPx size={16} /> <Border color="strong" /> <DivPx size={16} />
        </div>
        <div className={s.about}>
            <About reverse />
        </div>
    </div>
);

Footer.defaultProps = {
    offlineMode: true,
};
